import React, { useState, useEffect } from 'react';
import { getStats } from './api';
import ServicesAdmin    from './sections/ServicesAdmin';
import PortfolioAdmin   from './sections/PortfolioAdmin';
import PricingAdmin     from './sections/PricingAdmin';
import MessagesAdmin    from './sections/MessagesAdmin';
import QuotesAdmin      from './sections/QuotesAdmin';
import PromotionsAdmin  from './sections/PromotionsAdmin';

const sections = [
  { key:'dashboard',   label:'Dashboard',   icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
  { key:'sep1',        label:'',            icon:'', sep:true },
  { key:'services',    label:'Services',    icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93A10 10 0 1 1 4.93 19.07 10 10 0 0 1 19.07 4.93"/></svg> },
  { key:'portfolio',   label:'Portfolio',   icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg> },
  { key:'promotions',  label:'Promotions',  icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg> },
  { key:'pricing',     label:'Pricing',     icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> },
  { key:'sep2',        label:'',            icon:'', sep:true },
  { key:'messages',    label:'Messages',    icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, badge:'newMsg' },
  { key:'quotes',      label:'Quotes',      icon:<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> },
];

const AdminDashboard = ({ username, onLogout }) => {
  const [active, setActive] = useState('dashboard');
  const [stats, setStats]   = useState(null);

  useEffect(() => {
    getStats().then(r => { if (r.success) setStats(r.data); });
  }, [active]);

  const statCards = stats ? [
    { num: stats.contacts,  lbl: 'Total Messages',  icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, bg:'#e3f2fd', color:'#1565c0' },
    { num: stats.newMsg,    lbl: 'New Messages',    icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>, bg:'#fff3e0', color:'#e65100' },
    { num: stats.quotes,    lbl: 'Quote Requests',  icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>, bg:'#f3e5f5', color:'#6a1b9a' },
    { num: stats.portfolio, lbl: 'Projects',        icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>, bg:'#e8f5e9', color:'#2e7d32' },
    { num: stats.services,  lbl: 'Services',        icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93A10 10 0 1 1 4.93 19.07"/></svg>, bg:'#fce4ec', color:'#ad1457' },
    { num: stats.pricing,   lbl: 'Pricing Plans',   icon:<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>, bg:'#fff8e1', color:'#f57f17' },
  ] : [];

  const titleMap = { dashboard:'Dashboard Overview', services:'Manage Services', portfolio:'Manage Portfolio', promotions:'Manage Promotions', pricing:'Manage Pricing', messages:'Messages', quotes:'Quote Requests' };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img
            src="/images/logo.jpeg"
            alt="Saanvi Innovations"
            style={{
              height: 34, width: 'auto', maxWidth: 150, objectFit: 'contain', display: 'block',
              filter: 'invert(1) hue-rotate(180deg) brightness(1.15) saturate(1.4)',
            }}
            onError={e => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          {/* Fallback */}
          <div className="sidebar-logo-fallback" style={{ display:'none', alignItems:'center', gap:8 }}>
            <div className="sidebar-logo-icon">S</div>
            <div className="sidebar-logo-text">
              <div className="name">SAANVI</div>
              <div className="sub">Admin Panel</div>
            </div>
          </div>
        </div>

        <nav className="admin-nav">
          {sections.map(s => {
            if (s.sep) return <div key={s.key} style={{ height:1, background:'rgba(255,255,255,0.06)', margin:'8px 0' }} />;
            return (
              <div key={s.key} className={`admin-nav-item ${active===s.key?'active':''}`} onClick={() => setActive(s.key)}>
                <span className="nav-icon">{s.icon}</span>
                {s.label}
                {s.badge && stats?.[s.badge] > 0 && <span className="admin-nav-badge">{stats[s.badge]}</span>}
              </div>
            );
          })}
        </nav>

        <div className="admin-sidebar-footer">
          <div style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.3)', marginBottom:10, textAlign:'center' }}>
            Logged in as <strong style={{ color:'rgba(255,255,255,0.6)' }}>{username}</strong>
          </div>
          <button className="admin-logout-btn" onClick={onLogout}>🚪 Logout</button>
        </div>
      </aside>

      {/* Main */}
      <main className="admin-main">
        <div className="admin-topbar">
          <h1>{titleMap[active] || active}</h1>
          <div className="admin-topbar-right">
            <a href="/" target="_blank" rel="noreferrer" style={{ fontSize:'0.82rem', color:'#6c757d', textDecoration:'none', display:'flex', alignItems:'center', gap:6, padding:'6px 14px', border:'1px solid #e9ecef', borderRadius:50, background:'#f8f9fa' }}>
              🌐 View Website ↗
            </a>
            <div className="admin-user-badge">👤 {username}</div>
          </div>
        </div>

        <div className="admin-content">
          {active === 'dashboard' && (
            <div>
              {/* Stat cards */}
              {stats && (
                <div className="stats-grid-admin">
                  {statCards.map((c, i) => (
                    <div key={i} className="stat-card-admin">
                      <div className="stat-icon-wrap" style={{ background: c.bg }}>
                        <span>{c.icon}</span>
                      </div>
                      <div>
                        <div className="num" style={{ color: c.color }}>{c.num}</div>
                        <div className="lbl">{c.lbl}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Quick nav cards */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:18, marginBottom:28 }}>
                {[
                  { key:'services',  icon:'🛠️', title:'Services',  desc:'Add or edit website services' },
                  { key:'portfolio', icon:'🗂️', title:'Portfolio', desc:'Manage projects & images' },
                  { key:'pricing',   icon:'💰', title:'Pricing',   desc:'Update pricing plans' },
                ].map(c => (
                  <div key={c.key} onClick={() => setActive(c.key)}
                    style={{ background:'white', borderRadius:14, padding:'24px 20px', cursor:'pointer', border:'1px solid #f0f0f0', boxShadow:'0 2px 12px rgba(0,0,0,0.05)', transition:'all 0.3s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 10px 28px rgba(26,26,94,0.12)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='0 2px 12px rgba(0,0,0,0.05)'; }}>
                    <div style={{ fontSize:'2rem', marginBottom:10 }}>{c.icon}</div>
                    <div style={{ fontWeight:700, color:'#1a1a5e', marginBottom:4 }}>{c.title}</div>
                    <div style={{ fontSize:'0.82rem', color:'#6c757d' }}>{c.desc}</div>
                  </div>
                ))}
              </div>

              {/* Recent messages */}
              {stats?.recentContacts?.length > 0 && (
                <div style={{ background:'white', borderRadius:14, padding:24, boxShadow:'0 2px 12px rgba(0,0,0,0.05)', border:'1px solid #f0f0f0', marginBottom:20 }}>
                  <div className="admin-section-header" style={{ marginBottom:16 }}>
                    <h2 style={{ fontSize:'1rem' }}>✉️ Recent Messages</h2>
                    <button className="btn-admin-outline" style={{ fontSize:'0.78rem', padding:'5px 12px' }} onClick={() => setActive('messages')}>View All</button>
                  </div>
                  <table className="admin-table">
                    <thead><tr><th>Name</th><th>Subject</th><th>Status</th><th>Date</th></tr></thead>
                    <tbody>
                      {stats.recentContacts.map(m => (
                        <tr key={m.id}>
                          <td style={{ fontWeight:600 }}>{m.name}</td>
                          <td>{m.subject}</td>
                          <td><span className={`status-badge status-${m.status}`}>{m.status}</span></td>
                          <td style={{ fontSize:'0.78rem', color:'#adb5bd' }}>{new Date(m.created_at).toLocaleDateString('en-IN')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Recent quotes */}
              {stats?.recentQuotes?.length > 0 && (
                <div style={{ background:'white', borderRadius:14, padding:24, boxShadow:'0 2px 12px rgba(0,0,0,0.05)', border:'1px solid #f0f0f0' }}>
                  <div className="admin-section-header" style={{ marginBottom:16 }}>
                    <h2 style={{ fontSize:'1rem' }}>🚀 Recent Quote Requests</h2>
                    <button className="btn-admin-outline" style={{ fontSize:'0.78rem', padding:'5px 12px' }} onClick={() => setActive('quotes')}>View All</button>
                  </div>
                  <table className="admin-table">
                    <thead><tr><th>Name</th><th>Service</th><th>Budget</th><th>Status</th></tr></thead>
                    <tbody>
                      {stats.recentQuotes.map(q => (
                        <tr key={q.id}>
                          <td style={{ fontWeight:600 }}>{q.name}</td>
                          <td>{q.service}</td>
                          <td style={{ color:'#ff6b35', fontWeight:600 }}>{q.budget ? `₹${q.budget}` : '—'}</td>
                          <td><span className={`status-badge status-${q.status}`}>{q.status}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
          {active === 'services'   && <ServicesAdmin />}
          {active === 'portfolio'  && <PortfolioAdmin />}
          {active === 'promotions' && <PromotionsAdmin />}
          {active === 'pricing'    && <PricingAdmin />}
          {active === 'messages'   && <MessagesAdmin />}
          {active === 'quotes'     && <QuotesAdmin />}
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
